import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {forgotPassword, loginUser, resetPassword, verifyOTP, resendOTP} from '../../services/loginService';
import {isFormEmpty, parseJwt} from '../../utils/generalUtils';
import {Button} from '../reusableComponents/FormComponents/Button';
import {TextInput} from '../reusableComponents/FormComponents/TextInput';
import {Select} from '../reusableComponents/FormComponents/Select';
import {Icon} from '../reusableComponents/Icon';
import {SweetAlert} from '../reusableComponents/SweetAlert';
import './loginPage.scss';
import {showAlert} from '../../actions/miscellaneousActions';
import {saveUserData, logoutUser} from '../../actions/loginActions';
import {saveUserDataToLS, removeUserData} from '../../services/utilityServices';
import {Loader} from '../reusableComponents/Loader/Loader';
import {BasePage} from '../reusableComponents/BasePage';
import {Async} from '../reusableComponents/Async';
import {setLoading, setSuccess} from '../../actions/loadingActions';

const brandLogo = require('../../images/LMS_eConnect_Crop.jpg');

const queryString = require('query-string');

const certificate = require('../../images/certificate.svg');

export interface ILoginPageProps {
    history: IHistory;
    location: {
        search: any
    };
    isLoggedIn: boolean;
    elmsToken?: string;
}

export interface ILoginPageState {
    isLoading: boolean;
    userId: string;
    emailId: string;
    password: string;
    newPassword: string;
    confirmPassword: string;
    isUsernameTouched: boolean;
    isPwdTouched: boolean;
    isForgotPassword: boolean;
    isForgotLinkSent: boolean;
    isOTPSent: boolean;
    otp: string[];
    mfaUserId: string;
    mfaEmail: string;
    otpError: string;
    isResending: boolean;
    timeLeft: number;
    canResend: boolean;
    resendCountdown: number;
    isExpired: boolean;
    isOrgList?: boolean;
    orgsList?: Array<any>;
    selOrgId?: string;
}

export class LoginPageImpl extends React.PureComponent<ILoginPageProps, ILoginPageState> {
    constructor(props: ILoginPageProps) {
        super(props);
        this.state = {isLoading: false, userId: '', password: '', newPassword: '', confirmPassword: '', emailId: '', isForgotPassword: false, isForgotLinkSent: false, isUsernameTouched: false, isPwdTouched: false,isOTPSent: false,
        otp: ['', '', '', '', '', ''],
        mfaUserId: '',
        mfaEmail: '',
        otpError: '',
        isResending: false,
        timeLeft: 300,
        canResend: false,
        resendCountdown: 30,
        isExpired: false,
        isOrgList: false,
        orgsList: [],
        selOrgId: ''};
        this.timerRef = null;
        this.resendTimerRef = null;
    }

    private timerRef: any = null;
    private resendTimerRef: any = null;

    public componentDidMount() {
    document.title = 'Login Page';
    if (this.state.isOTPSent) {
        this.startTimer();
    }
}

    public componentWillMount() {
        this.clearTimers();
        
        // Log out the user if the token is 'unknown'
        if (this.props.elmsToken === 'unknown') {
            logoutUser();
            removeUserData();
            this.props.history.push('/');
            return;
        }
        
        const url = queryString.parse(this.props.location.search).redirect;
        if (this.props.isLoggedIn) {
            this.props.history.push(url || '/home');
        }
    }

    startTimer = () => {
    this.clearTimers();
    this.timerRef = setInterval(() => {
        this.setState((prevState: ILoginPageState) => {
            if (prevState.timeLeft <= 1) {
                clearInterval(this.timerRef);
                return {
                    ...prevState,
                    timeLeft: 0,
                    isExpired: true
                };
            }
            return {
                ...prevState,
                timeLeft: prevState.timeLeft - 1
            };
        });
    }, 1000);
};

startResendTimer = () => {
    this.clearResendTimer();
    this.resendTimerRef = setInterval(() => {
        this.setState((prevState: ILoginPageState) => {
            if (prevState.resendCountdown <= 1) {
                clearInterval(this.resendTimerRef);
                return {
                    ...prevState,
                    resendCountdown: 0,
                    canResend: true
                };
            }
            return {
                ...prevState,
                resendCountdown: prevState.resendCountdown - 1
            };
        });
    }, 1000);
};

clearTimers = () => {
    if (this.timerRef) {
        clearInterval(this.timerRef);
        this.timerRef = null;
    }
    this.clearResendTimer();
};

clearResendTimer = () => {
    if (this.resendTimerRef) {
        clearInterval(this.resendTimerRef);
        this.resendTimerRef = null;
    }
};

formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

    public handleLogin = async () => {
    const {userId, password} = this.state;
    this.setState({
        isUsernameTouched: true,
        isPwdTouched: true,
        isLoading: true
    });
    if (isFormEmpty({userId, password})) {
        this.setState({isLoading: false});
        return;
    }
    if (this.state.isOrgList && !this.state.selOrgId) {
        this.setState({isLoading: false});
        showAlert({
            title: 'Oops..!!',
            text: 'Please select an organisation to continue.',
            type: 'error',
            closeOnConfirm: true
        }, 'submission');
        return;
    }
    
    const url = queryString.parse(this.props.location.search).redirect;
    
    try {
        const res = await loginUser(userId, password, this.props.history, url, this.state.selOrgId);
        
        
        if (res && res.requireMFA === true) {
            this.setState({
                isLoading: false,
                isOTPSent: true,
                mfaUserId: res.userId,
                mfaEmail: res.email,
                otpError: '',
                timeLeft: 300,
                isExpired: false,
                canResend: false,
                resendCountdown: 30,
                otp: ['', '', '', '', '', '']
            }, () => {
                this.startTimer();
                this.startResendTimer();
            });
            showAlert({
                title: 'OTP Sent',
                text: `OTP sent to ${res.email}`,
                type: 'success',
                closeOnConfirm: true
            }, 'submission');
            return;
        }

        if (res && res.StatusCode === 200 && res.Message === "Organization Info") {
            this.setState({
                isLoading: false,
                isOrgList: true,
                orgsList: res.data
            });
            return;
        }
        
        if (res.StatusCode === 200) {
            this.setState({
                isLoading: false
            });
            this.processToken(res.token);
        } else if (res.StatusCode === 201 && res.Flag) {
            this.setState({
                userId: '',
                isLoading: false,
                emailId: '',
                password: '',
                confirmPassword: '',
                isUsernameTouched: false,
                isPwdTouched: false,
                isForgotPassword: false,
                isForgotLinkSent: true
            });
        }
    } catch (error) {
        console.error(' Login error:', error);
        this.setState({isLoading: false});
    }
}

    public handleVerifyOTP = async () => {
    const {otp, mfaUserId, isExpired} = this.state;
    const otpValue = otp.join('');
    
    //  Validation
    if (otpValue.length !== 6) {
        this.setState({otpError: 'Please enter complete 6-digit OTP'});
        return;
    }
    
    if (isExpired) {
        this.setState({otpError: 'OTP has expired. Please resend.'});
        return;
    }
    
    this.setState({isLoading: true, otpError: ''});
    
    try {
        const res = await verifyOTP(mfaUserId, otpValue, this.state.selOrgId);
        
        if (res && res.success) {
            //  Success
            this.clearTimers();
            this.setState({
                isLoading: false,
                isOTPSent: false
            });
            
            showAlert({
                title: ' Verification Successful',
                text: 'OTP verified successfully!',
                type: 'success',
                closeOnConfirm: true
            }, 'submission');
            
            this.processToken(res.token);
        } else {
            const errorMsg = res?.message || ' Invalid OTP. Please check your email and try again.';
            
            //  Check if attempts remaining
            let displayMsg = errorMsg;
            if (errorMsg.includes('attempts remaining')) {
                displayMsg = errorMsg;
            } else {
                displayMsg = ' The OTP you entered is incorrect. Please check your email for the correct OTP.';
            }
            
            this.setState({
                isLoading: false,
                otpError: displayMsg,
                otp: ['', '', '', '', '', '']
            });
            
            setTimeout(() => {
                const firstInput = document.getElementById('otp0');
                if (firstInput) {
                    (firstInput as HTMLInputElement).focus();
                }
            }, 100);
            
            showAlert({
                title: ' Invalid OTP',
                text: displayMsg,
                type: 'error',
                closeOnConfirm: true
            }, 'submission');
        }
    } catch (error) {
        console.error(' Verify OTP error:', error);
        
        let errorMsg = ' OTP verification failed. Please try again.';
        
        if ((error as any)?.response?.data?.message) {
            errorMsg = (error as any).response.data.message;
        }
        
        this.setState({
            isLoading: false,
            otpError: errorMsg,
            otp: ['', '', '', '', '', '']
        });
        
        showAlert({
            title: ' Verification Failed',
            text: errorMsg,
            type: 'error',
            closeOnConfirm: true
        }, 'submission');
    }
}

    public handleResendOTP = async () => {
    const {mfaUserId, canResend} = this.state;
    if (!canResend) return;
    
    this.setState({isResending: true, otpError: ''});
    
    try {
        const res = await resendOTP(mfaUserId);
        
        if (res && res.success) {
            this.clearTimers();
            this.setState({
                isResending: false,
                otp: ['', '', '', '', '', ''],
                timeLeft: 300,
                isExpired: false,
                canResend: false,
                resendCountdown: 30
            }, () => {
                this.startTimer();
                this.startResendTimer();
            });
            showAlert({
                title: 'OTP Resent',
                text: 'New OTP sent to your email',
                type: 'success',
                closeOnConfirm: true
            }, 'submission');
        }
    } catch (error) {
        console.error(' Resend OTP error:', error);
        this.setState({
            isResending: false,
            otpError: (error as any)?.message || 'Failed to resend OTP'
        });
    }
}

public handleOtpPaste = (event: React.ClipboardEvent) => {
    event.preventDefault();
    
    // Get pasted data
    const pastedData = event.clipboardData.getData('text');
    const digits = pastedData.replace(/\D/g, '').split('');
    
    const newOtp = [...this.state.otp];
    for (let i = 0; i < digits.length && i < 6; i++) {
        newOtp[i] = digits[i];
    }
    
    this.setState({otp: newOtp, otpError: ''});
    
    const lastIndex = Math.min(digits.length - 1, 5);
    setTimeout(() => {
        const lastInput = document.getElementById(`otp${lastIndex}`);
        if (lastInput) {
            (lastInput as HTMLInputElement).focus();
        }
    }, 50);
    
    if (newOtp.every(digit => digit !== '')) {
        setTimeout(() => {
            this.handleVerifyOTP();
        }, 300);
    }
};

    public handleBackToLogin = () => {
    this.setState({
        isOTPSent: false,
        otp: ['', '', '', '', '', ''],
        mfaUserId: '',
        mfaEmail: '',
        otpError: '',
        isResending: false,
        timeLeft: 300,
        isExpired: false,
        canResend: false,
        resendCountdown: 30
    });
};

    public handleOtpChange = (index: number, value: string) => {
    if (value && !/^[0-9]$/.test(value)) {
        return;
    }
    const newOtp = [...this.state.otp];
    newOtp[index] = value;
    this.setState({otp: newOtp, otpError: ''});
    
    if (value && index < 5) {
        const nextInput = document.getElementById(`otp${index + 1}`);
        if (nextInput) {
            setTimeout(() => {
                (nextInput as HTMLInputElement).focus();
            }, 50);
        }
    }
};

public handleOtpKeydown = (index: number, event: React.KeyboardEvent) => {
    if (event.key === 'Backspace') {
        if (!this.state.otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp${index - 1}`);
            if (prevInput) {
                setTimeout(() => {
                    (prevInput as HTMLInputElement).focus();
                }, 50);
            }
        }
    }
    if (event.key === 'Enter') {
        this.handleVerifyOTP();
    }
};

    public handleForgotPassword = async () => {
        const {emailId} = this.state;
        if (isFormEmpty({emailId})) {
            return;
        }
        this.setState({
            isLoading: true
        });
        await forgotPassword(emailId).then((res) => {
            showAlert({
                    title: 'Done..!!',
                    text: 'We have sent an Email with a temporary password to reset your account password.',
                    type: 'success',
                    closeOnConfirm: true
                },
                'submission');
            this.setState({
                userId: '',
                isLoading: false,
                emailId: '',
                password: '',
                confirmPassword: '',
                isUsernameTouched: false,
                isPwdTouched: false,
                isForgotPassword: false,
                isForgotLinkSent: true
            });
        }).catch(() => {
            this.setState({
                isLoading: false
            });
        });
    }

    public resetPassword = async () => {
        const {emailId, password, newPassword, confirmPassword} = this.state;
        if (isFormEmpty({emailId, password, confirmPassword})) {
            return;
        }

        if (newPassword !== confirmPassword) {
            showAlert({
                    title: 'Oops..!!',
                    text: 'New password and Confirm password must be same.',
                    type: 'error',
                    closeOnConfirm: true
                },
                'submission');
            return;
        }
        if (confirmPassword.length < 8) {
            showAlert({
                    title: 'Oops..!!',
                    text: 'Password should have minimum 8 characters.',
                    type: 'error',
                    closeOnConfirm: true
                },
                'submission');
            return;
        }

        this.setState({
            isLoading: true
        });

        await resetPassword({UserId: emailId, 'OldPwd': password, 'NewPwd': newPassword}).then((res) => {
            showAlert({
                    title: 'Done..!!',
                    text: 'Password reset done, Please login to continue..',
                    type: 'success',
                    closeOnConfirm: true
                },
                'submission');
            this.setState({
                userId: '',
                emailId: '',
                isLoading: false,
                password: '',
                confirmPassword: '',
                isUsernameTouched: false,
                isPwdTouched: false,
                isForgotPassword: false,
                isForgotLinkSent: false
            });
        }).catch(() => {
            this.setState({
                isLoading: false
            });
        });
    }
    public processToken = async (elmsToken, verifyToken: boolean = false) => {
        let token = parseJwt(elmsToken); 
        if(verifyToken) {
            //Need to verify the user with server before work
        }
        const url = queryString.parse(this.props.location.search).redirect;
        let session = {
            userUID: token.UniqueID,
            accessLevel: token.AccessLevel,
            Organization: token.Organization,
            OrganizationName: token.OrganizationName,
            LogoURL: token.LogoURL,
            isLoggedIn: true,
            token: elmsToken, 
            category: token.category, 
        }
        await saveUserData(session);
        await saveUserDataToLS(session);
        this.props.history.push(url || '/home');
    }
    public renderLoggingIn() { 
        this.processToken(this.props.elmsToken, true)
        return <div className="login-page"> 
                {<Loader type={'submission'}/> }
                <img className="certificate" alt={'brand-logo'} src={certificate}/>
                <div className="login-form">
                    <img src={brandLogo} height="60" width="100" alt="SPI"/>
                    <div style={{marginTop: '10px'}}>
                        <h4>Logging in. Please wait..</h4>
                    </div>
                </div>
            </div>
    }

    public render() {
    const {
        isForgotPassword, emailId, userId, password, newPassword, confirmPassword,
        isUsernameTouched, isPwdTouched, isForgotLinkSent, isLoading,
        isOTPSent, otp, mfaEmail, otpError, isResending
    } = this.state;
    const { elmsToken } = this.props;
    const { timeLeft, isExpired, canResend, resendCountdown } = this.state;
    
    if(elmsToken && elmsToken !== 'unknown') {
        return this.renderLoggingIn();
    }
    
    return <div className="login-page">
        <SweetAlert/>
        {isLoading && <Loader type={'submission'}/>}
        <img className="certificate" alt={'brand-logo'} src={certificate}/>
        
        {/*  OTP SECTION WITH TIMER */}
        {isOTPSent ? (
            <div className="login-form" style={{
                background: '#ffffff',
                borderRadius: '16px',
                padding: '28px 26px',
                boxShadow: '0 10px 30px rgba(30, 41, 59, 0.08)',
                border: '1px solid #eef0f4'
            }}>
                <img src={brandLogo} height="60" width="100" alt="SPI"/>
                <h4 style={{ margin: '14px 0 4px', color: '#1e293b', fontWeight: 700 }}>
                     OTP Verification
                </h4>
                <p style={{ margin: '4px 0 14px', color: '#64748b', fontSize: '14px' }}>
                    OTP sent to <strong style={{ color: '#334155' }}>{mfaEmail}</strong>
                </p>
                
                {/* ⏱ TIMER SECTION */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '6px 0 16px'
                }}>
                    <div style={{
                        position: 'relative',
                        width: '78px',
                        height: '78px',
                        filter: isExpired ? 'drop-shadow(0 0 6px rgba(229, 62, 62, 0.35))' : 'none'
                    }}>
                        <svg 
                            className="timer-circle" 
                            viewBox="0 0 40 40" 
                            style={{
                                width: '78px',
                                height: '78px',
                                transform: 'rotate(-90deg)'
                            }}
                        >
                            <circle 
                                className="timer-bg" 
                                cx="20" cy="20" r="17" 
                                fill="none" 
                                stroke="#eef1f6" 
                                strokeWidth="3.5" 
                            />
                            <circle 
                                className="timer-progress" 
                                cx="20" cy="20" r="17"
                                fill="none"
                                stroke={isExpired ? '#e53e3e' : '#4a6cf7'}
                                strokeWidth="3.5"
                                strokeLinecap="round"
                                strokeDasharray="106.8"
                                strokeDashoffset={106.8 * (1 - timeLeft / 300)}
                                style={{
                                    transition: 'stroke-dashoffset 1s linear, stroke 0.3s ease',
                                    animation: isExpired ? 'blink 0.9s ease-in-out infinite' : 'none'
                                }}
                            />
                        </svg>
                        <span style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: '17px',
                            fontWeight: 700,
                            letterSpacing: '0.3px',
                            color: isExpired ? '#e53e3e' : '#2d3748',
                            animation: isExpired ? 'blink 0.9s ease-in-out infinite' : 'none'
                        }}>
                            {this.formatTime(timeLeft)}
                        </span>
                    </div>
                </div>
                
                {/*  OTP INPUTS */}
                <div className="otp-inputs" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    margin: '4px 0 12px'
                }}>
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            id={`otp${index}`}
                            type="text"
                            maxLength={1}
                            value={digit}
                            onChange={(e) => this.handleOtpChange(index, e.target.value)}
                            onKeyDown={(e) => this.handleOtpKeydown(index, e)}
                            onPaste={this.handleOtpPaste}
                            disabled={isExpired}
                            autoFocus={index === 0 && !isExpired}
                            style={{
                                width: '46px',
                                height: '54px',
                                textAlign: 'center',
                                fontSize: '22px',
                                fontWeight: 700,
                                border: isExpired ? '2px solid #e53e3e' : '2px solid #e2e8f0',
                                borderRadius: '12px',
                                outline: 'none',
                                background: isExpired ? '#fff5f5' : '#f8fafc',
                                color: isExpired ? '#e53e3e' : '#1e293b',
                                boxShadow: isExpired ? 'none' : '0 1px 2px rgba(15, 23, 42, 0.04)',
                                transition: 'all 0.2s',
                                animation: isExpired ? 'blink 0.9s ease-in-out infinite' : 'none',
                                cursor: isExpired ? 'not-allowed' : 'text'
                            }}
                            onFocus={(e) => {
                                if (!isExpired) {
                                    e.target.style.borderColor = '#4a6cf7';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(74, 108, 247, 0.18)';
                                    e.target.style.background = 'white';
                                }
                            }}
                            onBlur={(e) => {
                                if (!isExpired) {
                                    e.target.style.borderColor = '#e2e8f0';
                                    e.target.style.boxShadow = '0 1px 2px rgba(15, 23, 42, 0.04)';
                                    e.target.style.background = '#f8fafc';
                                }
                            }}
                        />
                    ))}
                </div>
                
                {/*  ERROR MESSAGE */}
                {otpError && (
                    <div style={{
                        color: '#e53e3e',
                        background: '#fff5f5',
                        border: '1px solid #fed7d7',
                        borderRadius: '8px',
                        padding: '6px 10px',
                        fontSize: '13px',
                        textAlign: 'center',
                        margin: '6px 0',
                        fontWeight: 500
                    }}>
                        {otpError}
                    </div>
                )}
                
                {/*  VERIFY BUTTON */}
                <div className="button-container-otp" style={{ marginTop: '14px' }}>
                    <Button 
                        label="Verify OTP" 
                        onClick={this.handleVerifyOTP}
                    />
                    {(isExpired || otp.join('').length !== 6) && !isLoading && (
                        <div style={{
                            fontSize: '12px',
                            color: '#e53e3e',
                            textAlign: 'center',
                            marginTop: '8px',
                            fontWeight: 500
                        }}>
                            {isExpired ? 'OTP Expired. Please resend.' : 'Please enter complete 6-digit OTP'}
                        </div>
                    )}
                </div>
                
                <div style={{
                    textAlign: 'center',
                    marginTop: '18px',
                    paddingTop: '16px',
                    borderTop: '1px solid #eef1f6',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <span 
                        onClick={canResend ? this.handleResendOTP : undefined}
                        style={{
                            color: canResend ? '#4a6cf7' : '#a0aec0',
                            background: canResend ? '#eef2ff' : '#f1f5f9',
                            cursor: canResend ? 'pointer' : 'not-allowed',
                            padding: '7px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: 600,
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            if (canResend) {
                                (e.target as HTMLElement).style.background = '#e0e7ff';
                                (e.target as HTMLElement).style.color = '#4338ca';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (canResend) {
                                (e.target as HTMLElement).style.background = '#eef2ff';
                                (e.target as HTMLElement).style.color = '#4a6cf7';
                            }
                        }}
                    >
                        {isResending ? 'Sending...' : !canResend ? `Resend in ${resendCountdown}s` : ' Resend OTP'}
                    </span>
                    <span 
                        onClick={this.handleBackToLogin}
                        style={{
                            color: '#64748b',
                            background: '#f8fafc',
                            cursor: 'pointer',
                            padding: '7px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: 600,
                            transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                            (e.target as HTMLElement).style.background = '#eef1f6';
                            (e.target as HTMLElement).style.color = '#1e293b';
                        }}
                        onMouseLeave={(e) => {
                            (e.target as HTMLElement).style.background = '#f8fafc';
                            (e.target as HTMLElement).style.color = '#64748b';
                        }}
                    >
                        ← Back to Login
                    </span>
                </div>
            </div>
        ) : (
            !isForgotLinkSent ? (
                <div className="login-form">
                    <img src={brandLogo} height="60" width="100" alt="SPI"/>
                    <h5>{isForgotPassword ? '' : ''}</h5>
                    {isForgotPassword && <h6>Please enter your Email to reset password</h6>}
                    <div className="input-container">
                        {!isForgotPassword ? [
                            <InputField
                                id="userId"
                                type="text"
                                icon="id-card"
                                key={1}
                                hintText=""
                                onChange={e => {
                                    this.setState({userId: e.target.value, isUsernameTouched: true, isOrgList: false, selOrgId: ''});
                                }}
                                value={userId}
                                isTouched={isUsernameTouched}
                            />,
                            <InputField
                                id="password"
                                type="password"
                                icon="key"
                                key={2}
                                hintText=""
                                onChange={e => {
                                    this.setState({password: e.target.value, isPwdTouched: true, isOrgList: false, selOrgId: ''});
                                }}
                                value={password}
                                isTouched={isPwdTouched}
                            />,
                            this.state.isOrgList && (
                                <div className="text-input" key="orgDropdown" style={{marginTop: '0px'}}>
                                    <Icon size="2x" icon="building" />
                                    <Select
                                        hintText="Select Organisation..."
                                        menuItems={this.state.orgsList || []}
                                        multiple={false}
                                        value={this.state.selOrgId || ''}
                                        onChange={(event, selectedValues) => {
                                            this.setState({ selOrgId: selectedValues });
                                        }}
                                    />
                                </div>
                            )
                        ] : 
                            <InputField
                                id="emailId"
                                type="email"
                                icon="id-card"
                                key={3}
                                hintText="Email"
                                onChange={e => this.setState({emailId: e.target.value, isUsernameTouched: true})}
                                value={emailId}
                                isTouched={isUsernameTouched}
                            />
                        }
                    </div>
                    {!isForgotPassword ? [
                        <div key={4} className="button-container">
                            <Button label="Login" onClick={this.handleLogin}/>
                        </div>,
                        <div className="forgot-password-link" key={5} onClick={() => {
                            this.setState({
                                userId: '',
                                emailId: '',
                                password: '',
                                confirmPassword: '',
                                isUsernameTouched: false,
                                isPwdTouched: false,
                                isForgotPassword: true,
                                isForgotLinkSent: false
                            });
                        }}>
                            Forgot password?
                        </div>
                    ] : [
                        <div key={6} className="button-container">
                            <Button label="Send" onClick={this.handleForgotPassword}/>
                        </div>,
                        <div className="forgot-password-link" key={7} onClick={() => {
                            this.setState({
                                userId: '',
                                emailId: '',
                                password: '',
                                confirmPassword: '',
                                isUsernameTouched: false,
                                isPwdTouched: false,
                                isForgotPassword: false,
                                isForgotLinkSent: false
                            });
                        }}>
                            Return to Login?
                        </div>
                    ]}
                </div>
            ) : (
                <div className="login-form">
                    <img src={brandLogo} height="60" width="100" alt="SPI"/>
                    <h3>Reset Password</h3>
                    <div className="input-container">
                        <InputField
                            id="userId"
                            type="text"
                            icon="id-card"
                            key={8}
                            hintText="Email"
                            onChange={e => this.setState({emailId: e.target.value, isUsernameTouched: true})}
                            value={emailId}
                            isTouched={isUsernameTouched}
                        />
                        <InputField
                            id="oldpwd"
                            type="password"
                            icon="key"
                            key={9}
                            hintText="Temporary Password"
                            onChange={e => this.setState({password: e.target.value, isPwdTouched: true})}
                            value={password}
                            isTouched={false}
                        />
                        <InputField
                            id="newPwd"
                            type="password"
                            icon="key"
                            key={10}
                            hintText="New Password"
                            onChange={e => this.setState({newPassword: e.target.value, isPwdTouched: true})}
                            value={newPassword}
                            isTouched={false}
                        />
                        <InputField
                            id="conPwd"
                            type="password"
                            icon="key"
                            key={11}
                            hintText="Confirm Password"
                            onChange={e => this.setState({confirmPassword: e.target.value, isPwdTouched: true})}
                            value={confirmPassword}
                            isTouched={false}
                        />
                    </div>
                    <div key={12} className="button-container">
                        <Button label="Reset" onClick={this.resetPassword}/>
                    </div>
                </div>
            )
        )}
    </div>;
}
}

export function mapStateToProps(state, ownProps) {
    const elmsToken = ownProps.match.params.token; 
    return {
        isLoggedIn: state.login.get('isLoggedIn'), elmsToken
    };
}

export const LoginPage = withRouter(connect<{}, {}, ILoginPageProps>(mapStateToProps)(LoginPageImpl) as any);

const InputField = ({hintText, icon, id, type, onChange, value, isTouched}) => {
    return <div className="text-input" key={id + '1'}>
        <Icon size="2x" icon={icon}/>
        <TextInput
            onChange={onChange}
            hintText={hintText}
            id={id}
            type={type}
            errorText={isTouched && value.length < 1 ? 'This is required' : ''}
            required
            value={value}
        />
    </div>;

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoginPage/index.tsx